import React, { FC } from 'react';
import { OpeningHeader } from './OpeningHeader';
import { SearchAndFilterHeader } from './SearchAndFilterHeader';
import { HeaderProps } from './props';
import './styles.scss';

export const Header: FC<HeaderProps> = ({ activeOpeningId, isActiveOpeningLoading }) => {
  return (
    <div className="talent-carrousel-header">
      {activeOpeningId ? (
        <OpeningHeader activeOpeningId={activeOpeningId} isActiveOpeningLoading={isActiveOpeningLoading} />
      ) : (
        <SearchAndFilterHeader />
      )}
    </div>
  );
};
